import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const BirthdayYear = (props) => {
	const { t } = useTranslation();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);
	const pageData = useSelector(state => state.pageData);
	const controller = pageData.controller;
	const userData = useSelector(state => state.userData);

	const registerField = () => {
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;

		if (validator && form_component.required) {
			const fieldName = 'birthday[year]';

			try {
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}

				validator.addField(fieldName, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					},
					selector: `select[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => {
		registerField();
	}, [fv, controller, form_component.required, t]);

	useEffect(() => {
		const handleReinitialization = () => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);

		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t]);

	const yearStartRaw = parseInt(form_component.year_select_start, 10);
	const yearEndRaw = parseInt(form_component.year_select_end, 10);
	const yearStart = Number.isNaN(yearStartRaw) ? 1950 : yearStartRaw;
	const yearEnd = Number.isNaN(yearEndRaw) ? new Date().getFullYear() : yearEndRaw;
	const lo = Math.min(yearStart, yearEnd);
	const hi = Math.max(yearStart, yearEnd);

	var years = [];
	if (form_component.date_select_na) {
		years[0] = t('不適用');
	}
	for (let i = lo; i <= hi; ++i) {
		years[i] = i;
	}

	return (
		<div className="d-flex align-items-center">
			<div className="me-3">
				<div className="mb-3 form-group select">
					<select
						className="form-select-sm w-date form-select"
						defaultValue={userData && userData.birthday ? userData.birthday.year : ''}
						name="birthday[year]"
					>
						<option value="">-</option>
						{(() => {
							const components = [];

							years.map((year, index) => {
								components.push(
									<option key={`year-${index}`} value={year}>{year}</option>
								);
							});

							return components;
						})()}
					</select>
				</div>
			</div>
			<div className="pb-3">{t('年')}</div>
		</div>
	);
}

export default BirthdayYear;
